import {Skeleton} from "@mui/material";

export default function SkeletonInstitutionCard() {
    return (
        <div className="intst-card">
            <Skeleton variant="rectangular" width='100%' height={180} className="card-img" />
            <div className="card-body">
                <Skeleton variant="text" width={200} height={30} className="card-title"/>
                <Skeleton variant="text" width={160} height={20}  className="card-description" />
                <Skeleton variant="text" width={100} height={20} />
            </div>
        </div>
    );
}
